import { ApiBase } from '../Implementation/ApiBase';
export class NoteInternalApi extends ApiBase {
    areNotesSupported() {
        const currentLayout = this.getLayoutApi().getCurrentLayout();
        if (currentLayout.EnablePivot) {
            return false;
        }
        return true;
    }
}
